import MetaProvider from '@/contexts/metaContext';
import '@/styles/globals.css';
import Script from 'next/script';

export default function App({ Component, pageProps }) {
  return (
    <>
      <Script strategy="beforeInteractive" src={`${process.env.NEXT_CHECKOUT_URL}/widget/squad.min.js?v="20240925`} />

      <MetaProvider>
        <Component {...pageProps} />
      </MetaProvider>
    </>
  );
}
